import Vue from 'vue'
import moment from 'moment'
import dictionary from './dictionary'

Vue.filter('format', (val, format) => {
  if (val === '' || val === null || val === '-') return ''
  return moment(new Date(val)).format(format || 'YYYY-MM-DD')
})

Vue.filter('formatMoney', val => {
  var str = (val / 100).toFixed(2) + ''
  var intSum = str.substring(0, str.indexOf('.')).replace(/\B(?=(?:\d{3})+$)/g, ',') // 取到整数部分
  var dot = str.substring(str.length, str.indexOf('.')) // 取到小数部分搜索
  var ret = intSum + dot
  return ret
})

Vue.filter('unitConvert', num => {
  // var moneyUnits = ['元', '万元', '亿元', '万亿']
  // var dividend = 10000
  var curentNum = num || 0
  // 转换数字
  // var curentUnit = moneyUnits[1]
  // 转换单位
  curentNum = curentNum / 10000
  curentNum = curentNum.toFixed(2)
  var numArr = curentNum.split('.')
  var currentNum = numArr[0]
  var result = ''
  while (currentNum.length > 3) {
    result = ',' + currentNum.slice(-3) + result
    currentNum = currentNum.slice(0, currentNum.length - 3)
  }
  if (currentNum) {
    result = currentNum + result
  }
  result = result + '.' + numArr[1]
  return result
})

Vue.filter('thousands', num => {
  var reg = /\d{1,3}(?=(\d{3})+$)/g
  return (num + '').replace(reg, '$&,')
})

Vue.filter('convert', limit => {
  var size = ''
  if (limit < 0.1 * 1024) {
    // 如果小于0.1KB转化成B
    size = limit.toFixed(2) + 'B'
  } else if (limit < 0.1 * 1024 * 1024) {
    // 如果小于0.1MB转化成KB
    size = (limit / 1024).toFixed(2) + 'KB'
  } else if (limit < 0.1 * 1024 * 1024 * 1024) {
    // 如果小于0.1GB转化成MB
    size = (limit / (1024 * 1024)).toFixed(2) + 'MB'
  } else {
    // 其他转化成GB
    size = (limit / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
  }

  var sizestr = size + ''
  var len = sizestr.indexOf('.')
  var dec = sizestr.substr(len + 1, 2)
  if (dec === '00') {
    // 当小数点后为00时 去掉小数部分
    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2)
  }
  return sizestr
})

Vue.filter('msgType', (val, format) => {
  const msgType = JSON.parse(val.message).msgtype
  console.log(msgType)
  let rdata
  switch (msgType) {
    case 0:
      rdata = val.realMsg
      break
    case '1':
      rdata = '[图片]'
      break
    case '2':
      rdata = '[语音]'
      break
    case '3':
      rdata = '[视频]'
      break
    case '4':
      rdata = '[位置]'
      break
    case '6':
      rdata = '[文件]'
      break
  }
  return rdata
})

// filter from dictionary
for (let key in dictionary) {
  Vue.filter(key, function(value) {
    let match = dictionary[key].filter(item => item.value === value)[0]
    return match ? match.text : ''
  })
}



// WEBPACK FOOTER //
// ./src/filter/index.js